import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";

import { db } from "../../firebase/firebaseConfig";
import { estilosGrupos } from "../../elementos/gruposEstilos";

export default function ModalCrearGrupo({ abierto, onCerrar, onGuardar }) {
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [examenes, setExamenes] = useState([]);
  const [opciones, setOpciones] = useState([]);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  // Exámenes desde la colección oficial (no quemados en el código)
  useEffect(() => {
    if (!abierto || opciones.length > 0) return;

    getDocs(collection(db, "examenes"))
      .then((snap) => {
        const lista = snap.docs
          .map((d) => d.data().Examen)
          .filter(Boolean)
          .sort((a, b) => String(a).localeCompare(String(b)));
        setOpciones(lista);
      })
      .catch((err) => console.error("Error cargando exámenes:", err));
  }, [abierto, opciones.length]);

  useEffect(() => {
    if (!abierto) return undefined;
    const alPresionar = (e) => e.key === "Escape" && onCerrar();
    window.addEventListener("keydown", alPresionar);
    return () => window.removeEventListener("keydown", alPresionar);
  }, [abierto, onCerrar]);

  if (!abierto) return null;

  const alternarExamen = (examen) =>
    setExamenes((previo) =>
      previo.includes(examen) ? previo.filter((x) => x !== examen) : [...previo, examen]
    );

  const guardar = async () => {
    if (!nombre.trim()) {
      setError("Escribe un nombre para el grupo.");
      return;
    }

    setGuardando(true);
    setError("");

    try {
      await onGuardar({
        nombre: nombre.trim(),
        descripcion: descripcion.trim(),
        examenes,
      });
      setNombre("");
      setDescripcion("");
      setExamenes([]);
    } catch (err) {
      console.error("Error creando grupo:", err);
      setError("No fue posible crear el grupo. Revisa la conexión e inténtalo de nuevo.");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div className="gg gg-fondo" onMouseDown={(e) => e.target === e.currentTarget && onCerrar()}>
      <style>{estilosGrupos}</style>

      <div className="gg-modal" role="dialog" aria-modal="true" aria-labelledby="gg-titulo-crear">
        <div className="gg-modal__cabecera">
          <h2 id="gg-titulo-crear">Nuevo grupo</h2>
          <button type="button" className="gg-cerrar" onClick={onCerrar} aria-label="Cerrar">×</button>
        </div>

        {error && <p role="alert" className="gg-alerta">{error}</p>}

        <div className="gg-campo">
          <label htmlFor="gg-nombre">Nombre</label>
          <input
            id="gg-nombre"
            className="gg-input"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            placeholder="Por ejemplo: Preparación UNAL 2027-1"
            autoFocus
          />
        </div>

        <div className="gg-campo">
          <label htmlFor="gg-descripcion">Descripción</label>
          <textarea
            id="gg-descripcion"
            className="gg-textarea"
            value={descripcion}
            onChange={(e) => setDescripcion(e.target.value)}
            placeholder="Para qué se prepara el grupo, horarios, sede…"
          />
        </div>

        <fieldset className="gg-campo" style={{ border: 0, padding: 0, margin: "0 0 14px" }}>
          <legend>Exámenes que preparan</legend>
          {opciones.length === 0 ? (
            <p className="gg-sutil">Cargando exámenes…</p>
          ) : (
            <div className="gg-checks">
              {opciones.map((examen) => (
                <label key={examen}>
                  <input
                    type="checkbox"
                    checked={examenes.includes(examen)}
                    onChange={() => alternarExamen(examen)}
                  />
                  {examen}
                </label>
              ))}
            </div>
          )}
        </fieldset>

        <div className="gg-botonera">
          <button type="button" className="gg-btn" onClick={onCerrar}>Cancelar</button>
          <button type="button" className="gg-btn gg-btn--primario" onClick={guardar} disabled={guardando}>
            {guardando ? "Creando…" : "Crear grupo"}
          </button>
        </div>
      </div>
    </div>
  );
}